// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3Lcqe","inner":"Form_inner__3nZce","range":"Form_range__1laYU","name":"Form_name__3gTGW","actions":"Form_actions__2ugvs"};